import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { SelectorSpot, SpotSelectorState } from './spotSelectorTypes';

const initialState: SpotSelectorState = {
  isExpanded: false,
  spots: [],
  hasDropdown: true,
  isChanging: false
};

export const spotSelectorSlice = createSlice({
  initialState,
  name: 'spotSelector',
  reducers: {
    addSpots: (state, action: PayloadAction<SelectorSpot[]>) => {
      state.spots.push(...action.payload);
    },
    setSelectedSpotId: (state, action: PayloadAction<string>) => {
      state.selectedSpotId = action.payload;
    },
    setExpanded: (state, action: PayloadAction<boolean>) => {
      state.isExpanded = action.payload;
    },
    setHasDropdown: (state, action: PayloadAction<boolean>) => {
      state.hasDropdown = action.payload;
    },
    setSpotName: (state, action: PayloadAction<string>) => {
      state.spotName = action.payload;
    },
    clearSpotSelector: state => {
      return { ...initialState };
    },
    toggleSpotSelector: state => {
      state.isExpanded = !state.isExpanded;
    },
    addSpot: (state, action: PayloadAction<SelectorSpot>) => {
      state.spots.push(action.payload);
    },
    setIsChanging: (state, action: PayloadAction<boolean>) => {
      state.isChanging = action.payload;
    }
  }
});

export const spotSelectorReducer = spotSelectorSlice.reducer;

export const {
  addSpots,
  setSelectedSpotId,
  setExpanded,
  setHasDropdown,
  setSpotName,
  toggleSpotSelector,
  addSpot,
  clearSpotSelector,
  setIsChanging
} = spotSelectorSlice.actions;
